export const iconFontAwesomeTravelHotelTruckArrowRight = (
	<i className="fa-solid fa-truck-arrow-right"></i>
);
